
import { RoleType } from "@/types/profile";
import { RoleFeatures, DashboardFeature } from "./types";
import { patronFeatures } from "./patronFeatures";
import { djFeatures } from "./djFeatures";
import { performerFeatures } from "./performerFeatures";
import { promoterFeatures } from "./promoterFeatures";
import { venueOwnerFeatures } from "./venueOwnerFeatures";
import { bartenderFeatures } from "./bartenderFeatures";
import { securityFeatures } from "./securityFeatures";

export type { DashboardFeature };

export const roleFeatures: RoleFeatures = {
  'Patron': patronFeatures,
  'DJ': djFeatures,
  'Performer': performerFeatures,
  'Promoter': promoterFeatures,
  'Venue Owner': venueOwnerFeatures,
  'Employee': bartenderFeatures,  // Use bartenderFeatures for Employee role
  'Security': securityFeatures
};

export const getFeaturesByRole = (roleTypes: RoleType[] | undefined) => {
  if (!roleTypes || roleTypes.length === 0) {
    return roleFeatures['Patron'];
  }

  return roleTypes.reduce((acc, role) => {
    if (roleFeatures[role]) {
      acc.push(...roleFeatures[role]);
    }
    return acc;
  }, [] as DashboardFeature[]);
};
